import { useState } from "react";

type VersionIconType = {
    icon: JSX.Element;
    message: string;
    url: string;
};

const VersionIcon = ({ icon, message, url }: VersionIconType) => {
    const [showVersion, setShowVersion] = useState<boolean>(false);

    return (
        <div className="c-version-icon">
            <div
                className="c-version-icon__icon"
                onClick={() => setShowVersion(!showVersion)}
            >
                {icon}
            </div>
            {showVersion && (
                <div className="c-version-icon__container">
                    <div className="c-version-icon__container__triangle" />
                    <div className="c-version-icon__container__message">
                        <a
                            className="c-version-icon__container__message__url"
                            href={url}
                        >
                            {message}
                        </a>
                    </div>
                </div>
            )}
        </div>
    );
};

export default VersionIcon;
